<template>
  <el-scrollbar
    ref="scrollContainer"
    :vertical="false"
    class="scroll-container"
    @wheel.native.prevent="handleScroll"
  >
    <slot />
  </el-scrollbar>
</template>

<script>
const TAG_SPACING = 4

export default {
  name: 'ScrollPane',
  computed: {
    scrollWrapper() {
      return this.$refs.scrollContainer.$refs.wrap
    }
  },
  mounted() {
    this.scrollWrapper.addEventListener('scroll', this.emitScroll, true)
  },
  beforeDestroy() {
    this.scrollWrapper.removeEventListener('scroll', this.emitScroll)
  },
  methods: {
    handleScroll(e) {
      const delta = e.wheelDelta || -e.deltaY * 40
      this.scrollWrapper.scrollLeft += delta / 4
    },
    emitScroll() {
      this.$emit('scroll')
    },
    moveToTarget(currentTag) {
      const $container      = this.$refs.scrollContainer.$el
      const $containerWidth = $container.offsetWidth
      const $scrollWrapper  = this.scrollWrapper
      const tagList         = this.$parent.$refs.tag

      if (!tagList || tagList.length === 0) return

      const firstTag = tagList[0]
      const lastTag  = tagList[tagList.length - 1]

      if (firstTag === currentTag) {
        $scrollWrapper.scrollLeft = 0
        return
      }
      if (lastTag === currentTag) {
        $scrollWrapper.scrollLeft = $scrollWrapper.scrollWidth - $containerWidth
        return
      }

      const currentIndex         = tagList.findIndex(item => item === currentTag)
      const prevTag              = tagList[currentIndex - 1]
      const nextTag              = tagList[currentIndex + 1]
      const afterNextTagOffset   = nextTag.$el.offsetLeft + nextTag.$el.offsetWidth + TAG_SPACING
      const beforePrevTagOffset  = prevTag.$el.offsetLeft - TAG_SPACING

      if (afterNextTagOffset > $scrollWrapper.scrollLeft + $containerWidth) {
        $scrollWrapper.scrollLeft = afterNextTagOffset - $containerWidth
      } else if (beforePrevTagOffset < $scrollWrapper.scrollLeft) {
        $scrollWrapper.scrollLeft = beforePrevTagOffset
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll-container {
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  width:  100%;
  height: 100%;

  ::v-deep {
    .el-scrollbar__wrap {
      height: 100%;
      overflow-x: auto !important;
      overflow-y: hidden !important;
      padding-bottom: 8px;
      box-sizing: content-box;
      scrollbar-width: thin;
      scrollbar-color: rgba(148, 163, 184, 0.45) transparent;

      &::-webkit-scrollbar {
        width: 0;
        height: 3px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: rgba(148, 163, 184, 0.38);
        border-radius: 999px;
        border: 1px solid transparent;
        background-clip: content-box;
      }

      &::-webkit-scrollbar-thumb:hover {
        background: rgba(100, 116, 139, 0.56);
        background-clip: content-box;
      }
    }

    .el-scrollbar__bar {
      &.is-vertical {
        display: none !important;
      }

      &.is-horizontal {
        height: 2px;
        bottom: 2px;
        border-radius: 999px;
        background: transparent;
        opacity: 1;

        > div {
          background:    rgba(148, 163, 184, 0.48);
          border-radius: 999px;
          transition:    background 0.2s;
          &:hover { background: rgba(100, 116, 139, 0.66); }
        }
      }
    }
  }
}
</style>
